/* eslint-disable complexity */
import { createReducer, on } from '@ngrx/store';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { RetrieveSearchState } from '../../models/states/retrieve-search-state.interfaces';
import * as fromRetrieveSearchActions from '../actions/retrieve-search.actions';

export const RetrieveSearchStateKey = 'retrieveSearch';

const initialState: RetrieveSearchState = {
  isReady: false,
  isError: false,
  triggerRetrieveSearchLanding: false,
  retrieveSearchMcCacheKey: '',
  retrieveSearchDataList: null
};

export const retrieveSearchReducer = createReducer(
  initialState,
  on(
    fromRetrieveSearchActions.StoreRetrieveSearchInputValues,
    (
      state,
      {
        retrieveSearchMcCacheKey,
        triggerRetrieveSearchLanding,
        retrieveSearchOwRtResponse,
        retrieveSearchMcResponse
      }
    ) => {
      let retrieveSearchDataList: RetrieveSearchData[] | null = null;
      if (retrieveSearchOwRtResponse) {
        if (retrieveSearchOwRtResponse.length) {
          retrieveSearchDataList = retrieveSearchOwRtResponse.map((data) => {
            return {
              ...data,
              airports: [data.airports],
              dates: [data.dates]
            };
          });
        }
      } else if (retrieveSearchMcResponse) {
        retrieveSearchDataList = [retrieveSearchMcResponse.value];
      }

      return {
        ...state,
        retrieveSearchMcCacheKey,
        triggerRetrieveSearchLanding,
        retrieveSearchDataList: state.isReady
          ? state.retrieveSearchDataList
          : retrieveSearchDataList
      };
    }
  ),
  on(
    fromRetrieveSearchActions.LoadRetrieveSearchSuccess,
    (state, { retrieveSearchDataList }) => ({
      ...state,
      isReady: true,
      isError: false,
      retrieveSearchDataList
    })
  ),
  on(fromRetrieveSearchActions.LoadRetrieveSearchFailure, (state) => ({
    ...state,
    isReady: false,
    isError: true
  }))
);
